import { memo, useCallback, useEffect, useState } from "react";

import { UserRole, UserSearchFormValues } from "services/api/users/types";
import { getUserRolesAPI } from "services/api/users/api";
import { TextField } from "ui/components/TextField/TextField";
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { UserSearchFilterProps } from "./types";
import { initialUserSearchForm } from "services/api/users/consts";
import { useTranslate } from "helpers";

const UserSearchFilters: React.FC<UserSearchFilterProps> = (props) => {
  const { onSearchChange } = props;

  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<UserSearchFormValues>(
    initialUserSearchForm
  );
  const [roles, setRoles] = useState<UserRole[]>([]);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        setRoles(await getUserRolesAPI());
      } catch {
        setRoles([]);
      }
    };

    fetchRoles();
  }, []);

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormValues = { ...formValues, [name]: value };
    setFormValues(updatedFormValues);
    onSearchChange(updatedFormValues);
  };

  const handleDropdownChange = useCallback(
    (_e: any, name: string, item: DropdownOption) => {
      const updatedFormValues = { ...formValues, [name]: item.value };
      setFormValues(updatedFormValues);
      onSearchChange(updatedFormValues);
    },
    [formValues, onSearchChange]
  );

  const handleResetFormClick = useCallback(() => {
    setFormValues(initialUserSearchForm);
    onSearchChange(initialUserSearchForm);
  }, [onSearchChange]);

  const roleOptions: DropdownOption[] = roles.map((role) => ({
    value: role.id,
    text: role.name,
  }));

  return (
    <>
      <div className=" ">
        <div className="flex justify-between items-center gap-3">
          <div className="flex flex-wrap gap-3 flex-wrap">
            <div className="min-w-[200px]">
              <TextField
                type="text"
                name="search"
                value={formValues.search}
                onChange={handleSearchChange}
                placeholder={t("admin.search.placeholder")}
                startIcon="../media/icons/search.svg"
                cssClassName="bg-white"
              />
            </div>
            <div className="min-w-[200px]">
              <Dropdown
                name="roleId"
                placeholder={t("admin.user.search.roles")}
                options={roleOptions}
                onChange={handleDropdownChange}
                value={formValues.roleId}
                cssClassName="bg-white"
              />
            </div>
            <div className="min-w-[200px]">
              <TextField
                type="text"
                name="email"
                value={formValues.email}
                onChange={handleSearchChange}
                placeholder={t("admin.user.search.email")}
                endIcon="media/icons/email.svg"
                cssClassName="bg-white"
              />
            </div>
            <div className="min-w-[200px]">
              <TextField
                type="text"
                name="phone"
                value={formValues.phone}
                onChange={handleSearchChange}
                placeholder={t("admin.user.search.phone")}
                endIcon="media/icons/phone.svg"
                cssClassName="bg-white"
              />
            </div>
            <div className="min-w-[200px]">
              <TextField
                type="text"
                name="address"
                value={formValues.address}
                onChange={handleSearchChange}
                placeholder="Adresa"
                endIcon="media/icons/map.svg"
                cssClassName="bg-white"
              />
            </div>
            <div className="flex items-center">
              <span
                onClick={handleResetFormClick}
                className="text-xs font-bold cursor-pointer text-gray-700"
              >
                {t("admin.reset")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(UserSearchFilters);
